export const TOOL_ITEMS = {
    BRUSH: "BRUSH",
    LINE: "LINE",
    RECTANGLE: "RECTANGLE",
    CIRCLE: "CIRCLE",
    ARROW: "ARROW",
    ERASER: "ERASER",
    TEXT: "TEXT",
    TRIANGLE: "TRIANGLE",
    DIAMOND: "DIAMOND",
    AI_BRUSH: "AI_BRUSH",
    AI_BRUSH_ML: "AI_BRUSH_ML",
};

export const TOOL_ACTION_TYPES = {
    NONE: "NONE",
    DRAWING: "DRAWING",
    ERASING: "ERASING",
    WRITING: "WRITING",
    PANNING: "PANNING",
    RECOGNIZING: "RECOGNIZING",
}
export const BOARD_ACTIONS = {
    CHANGE_TOOL: "CHANGE_TOOL",
    DRAW_DOWN: "DRAW_DOWN",
    DRAW_MOVE: "DRAW_MOVE",
    DRAW_UP: "DRAW_UP",
    ERASE: "ERASE",
    CHANGE_ACTION_TYPE: "CHANGE_ACTION_TYPE",
    CHANGE_TEXT: "CHANGE_TEXT",
    UNDO: "UNDO",
    REDO: "REDO",
    RESET_ELEMENTS: 'RESET_ELEMENTS',
    REMOTE_UPDATE: 'REMOTE_UPDATE',
    SET_VIEWPORT: "SET_VIEWPORT",
    PAN_VIEWPORT: "PAN_VIEWPORT",
    ZOOM_VIEWPORT: "ZOOM_VIEWPORT",
    START_PAN: 'START_PAN',
    UPDATE_PAN_POINT: 'UPDATE_PAN_POINT',
    END_PAN: 'END_PAN',
    CLEAR_CANVAS: 'CLEAR_CANVAS',

}

export const ARROW_LENGTH = 20;
export const ELEMENT_ERASE_THRESHOLD = 15;

export const COLORS = {
    BLACK: "#000000",
    RED: "#ff0000",
    GREEN: "#00ff00",
    BLUE: "#0000ff",
    YELLOW: "#ffff00",
    ORANGE: "#ffa500",
    WHITE: "#ffffff",
    PURPLE: "#800080",
}

export const TOOLBOX_ACTIONS = {
    CHANGE_STROKE: "CHANGE_STROKE",
    CHANGE_FILL: "CHANGE_FILL",
    CHANGE_SIZE: "CHANGE_SIZE",
    UPDATE_COLORS: "UPDATE_COLORS",
}

export const FILL_TOOL_TYPES = [TOOL_ITEMS.RECTANGLE, TOOL_ITEMS.CIRCLE, TOOL_ITEMS.TRIANGLE,  TOOL_ITEMS.DIAMOND,];
export const STROKE_TOOL_TYPES = [TOOL_ITEMS.BRUSH, TOOL_ITEMS.LINE, TOOL_ITEMS.RECTANGLE, TOOL_ITEMS.CIRCLE, TOOL_ITEMS.ARROW, TOOL_ITEMS.TEXT, TOOL_ITEMS.AI_BRUSH,TOOL_ITEMS.TRIANGLE, TOOL_ITEMS.DIAMOND,];
export const SIZE_TOOL_TYPES = [TOOL_ITEMS.BRUSH, TOOL_ITEMS.LINE, TOOL_ITEMS.RECTANGLE, TOOL_ITEMS.CIRCLE, TOOL_ITEMS.ARROW, TOOL_ITEMS.TEXT, TOOL_ITEMS.AI_BRUSH,TOOL_ITEMS.TRIANGLE, TOOL_ITEMS.DIAMOND,];
